import { z } from 'zod'

export const excelExportSchema = z.object({
	groupBy: z.string(),
	purchasesToInclude: z.string(),
	exportContents: z.array(z.string()),
	highlightDirectDeal: z.boolean(),
	identifyOvercharges: z.boolean(),
	markComplete: z.boolean(),
})

export const pdfExportSchema = z.object({
	purchasesToInclude: z.string(),
	markComplete: z.boolean(),
})
